import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';
/*
 * Does deep merge. This is similar to `lodash` merge, but handles arrays differently:
 * `lodash` merges elements of arrays by their indices, this overwrites the existing
 * value with the array
 */
export const merge = (...sources) => {
    const result = {};
    mergeWith(result, ...sources, (_, srcValue) => {
        if (isArray(srcValue)) {
            return [...srcValue];
        }
        else {
            return undefined; // no customization: does the default merging for this field
        }
    });
    return result;
};
